/**
 * ---------------------------------------------------------------------------
 * VENNER — Hero: enlace de toda la foto en pantallas táctiles
 * ---------------------------------------------------------------------------
 *
 * El área de swipe de Prestige llama a preventDefault() en cada pointermove
 * mientras se arrastra. Con mouse eso no estorba, porque un clic sin mover no
 * genera pointermove. Con el dedo siempre hay micro-movimiento, así que el
 * navegador deja de sintetizar el clic y el enlace de la foto nunca abre.
 *
 * Aquí se reconstruye ese toque a mano, y sólo para punteros que no son mouse:
 * si el dedo casi no se movió y no fue una pulsación larga, es un toque y se
 * navega. Si se movió, era un swipe y no se hace nada, para no robarle el
 * gesto al carrusel.
 */

{
  const MAX_MOVEMENT_PX = 10;
  const MAX_DURATION_MS = 700;

  const onPointerDown = (event) => {
    const link = event.currentTarget;
    if (event.pointerType === 'mouse') return;
    link._vhTouch = { x: event.clientX, y: event.clientY, time: Date.now() };
  };

  const onPointerUp = (event) => {
    const link = event.currentTarget;
    const start = link._vhTouch;
    link._vhTouch = null;

    if (!start || event.pointerType === 'mouse') return;

    const moved = Math.hypot(event.clientX - start.x, event.clientY - start.y);
    if (moved > MAX_MOVEMENT_PX) return;
    if (Date.now() - start.time > MAX_DURATION_MS) return;

    const href = link.getAttribute('href');
    if (href) window.location.href = href;
  };

  const wire = (link) => {
    if (link._vhWired) return;
    link._vhWired = true;
    link.addEventListener('pointerdown', onPointerDown);
    link.addEventListener('pointerup', onPointerUp);
    link.addEventListener('pointercancel', () => { link._vhTouch = null; });
  };

  const wireAll = () => document.querySelectorAll('.venner-hero__slide-link').forEach(wire);

  wireAll();
  // El editor de temas vuelve a pintar la sección al cambiar un ajuste.
  document.addEventListener('shopify:section:load', wireAll);
}
